import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const May = () => {
    return (
        <Fragment>{SkipDays(5, 7, [])}</Fragment>  
    )
}